import React from "react";
import { Button } from "react-bootstrap";

const FormButtons = ({ errors, isSubmitting, handleSave }) => {
  return (
    <div className="d-flex flex-column flex-md-row align-items-center gap-3 mt-4 lg-ms-4">
      
      {Object.values(errors).some(msg => !!msg) && (
        <div className="text-danger fw-semibold small text-center text-md-start">
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          Hay errores en algunos campos. Por favor, corrígelos para continuar.
        </div>
      )}

      <Button
        variant="primary"
        onClick={handleSave}
        disabled={isSubmitting}
        className="ms-md-auto"
        style={{ backgroundColor: "#10407D", borderColor: "#10407D" }}
      >
        {isSubmitting ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Guardando...
          </>
        ) : (
          <>
            Siguiente
          </>
        )}
      </Button>
    </div>
  );
};

export default FormButtons;